import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({


  partTitle:{
    display:'flex',
    alignItems:'center',
    '& img':{
      marginRight: '10px'
    }
  },
  part:{
    padding: '0px 5px 0px 5px',
    marginTop: '25px'
  }
}));

export default useStyles;
